// // import React, { useContext } from "react";
// // // import { techStack } from "../constants";
// // import { ThemeContext } from "../themeProvider";

// // const Experience = () => {
// //   const theme = useContext(ThemeContext);
// //   const darkMode = theme.state.darkMode;
// //   return (
// //     <div
// //       id="experience"
// //       className={darkMode === true ? "bg-gray-100" : "bg-gray-700"}
// //     >
// //       <div className="max-w-7xl mx-auto x-4 sm:px-6 lg:px-8 px-4 md:mt-0 pt-20 pb-8">
// //         <h2
// //           className={
// //             darkMode
// //               ? "text-5xl font-bold px-4 md:px-0 text-center"
// //               : "text-5xl font-bold px-4 md:px-0 text-center text-white"
// //           }
// //         >
// //           WORK EXPERIENCE
// //         </h2>
// //         <div
// //           className={
// //             darkMode
// //               ? "mt-4 text-xl text-justify"
// //               : "mt-4 text-xl text-justify text-white"
// //           }
// //         >
// //           {/* <p
// //             className={
// //               darkMode
// //                 ? "mt-4 text-xl text-justify text-gray-500"
// //                 : "mt-4 text-xl text-justify text-white"
// //             }
// //           >
// //             Hi, I'm Manoj Kumar. I graduated with a degree in Computer Science
// //             and Engineering from Anand College of Engineering and Management
// //             Kapurthala, Punjab. I have previous experience as a Team Leader at
// //             NSB BPO Solution Pvt Ltd, and I am currently working at Indusnet
// //             Technologies Pvt Ltd in Kolkata. I consider myself a self-learner,
// //             always eager to explore and acquire new knowledge. I believe that
// //             curiosity is the driving force behind innovative thinking, and I am
// //             convinced that even the smallest piece of information can have a
// //             significant impact. Feel free to check out some of the projects I've
// //             developed on my GitHub profile or take a look at my resume for more
// //             details.
// //           </p> */}
// //           <div style={{ textAlign: "center" }}>
// //             <h2
// //               className={
// //                 darkMode
// //                   ? "text-xl font-bold text-black"
// //                   : "text-xl font-bold text-white"
// //               }
// //             >
// //               Indus Net Technologies Pvt Ltd
// //             </h2>
// //             <h3 className="text-sm font-bold ">
// //               Sep 2022 - May 2024 | Kolkata
// //             </h3>
// //           </div>
// //           <ul className="ml-20 list-disc">
// //             <li>
// //               I have Worked on multiple internal or external projects involving
// //               front-end and back-end development.
// //             </li>
// //             <li>
// //               Implemented user authentication and data encryption for enhanced
// //               security
// //             </li>
// //             <li>
// //               Utilized Node.js, Express.js, MongoDB, Swagger, and Git for
// //               development, documentation, and version control.
// //             </li>
// //             <li>
// //               Participated in code reviews, debugging, and troubleshooting to
// //               maintain code quality.
// //             </li>
// //             <li>
// //               Implemented Redux-toolkit for efficient state management,
// //               enhancing application performance.
// //             </li>
// //             <li>
// //               ontributed to the development of a reusable component library for
// //               future implementation.
// //             </li>
// //             <li>
// //               {" "}
// //               Solid experience with{" "}
// //               <span className="font-bold">
// //                 {" "}
// //                 HTML, Javascript, Node, Express, Mongodb , React, Strapi CMS and
// //                 Drupal CMS
// //               </span>{" "}
// //             </li>
// //           </ul>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Experience;

// import React, { useContext } from "react";
// import { ThemeContext } from "../themeProvider";

// const Experience = () => {
//   const theme = useContext(ThemeContext);
//   const darkMode = theme.state.darkMode;
//   return (
//     <div
//       id="experience"
//       className={darkMode === true ? "bg-gray-100" : "bg-gray-700"}
//     >
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-8">
//         <h2
//           className={
//             darkMode
//               ? "text-5xl font-bold px-4 md:px-0 text-center"
//               : "text-5xl font-bold px-4 md:px-0 text-center text-white"
//           }
//         >
//           WORK EXPERIENCE
//         </h2>
//         <div
//           className={
//             darkMode
//               ? "mt-4 text-xl text-justify"
//               : "mt-4 text-xl text-justify text-white"
//           }
//         >
//           <div style={{ textAlign: "center" }}>
//             <h2
//               className={
//                 darkMode
//                   ? "text-xl font-bold text-black"
//                   : "text-xl font-bold text-white"
//               }
//             >
//               Indus Net Technologies Pvt Ltd
//             </h2>
//             <h3 className="text-sm font-bold ">
//               Sep 2022 - May 2024 | Kolkata
//             </h3>
//           </div>
//           <ul className="ml-20 list-disc">
//             <li>
//               I have Worked on multiple internal or external projects involving
//               front-end and back-end development.
//             </li>
//             <li>
//               Implemented user authentication and data encryption for enhanced
//               security
//             </li>
//             <li>
//               Utilized Node.js, Express.js, MongoDB, Swagger, and Git for
//               development, documentation, and version control.
//             </li>
//             <li>
//               Participated in code reviews, debugging, and troubleshooting to
//               maintain code quality.
//             </li>
//             <li>
//               Implemented Redux-toolkit for efficient state management,
//               enhancing application performance.
//             </li>
//             <li>
//               ontributed to the development of a reusable component library for
//               future implementation.
//             </li>
//             <li>
//               {" "}
//               Solid experience with{" "}
//               <span className="font-bold">
//                 {" "}
//                 HTML, Javascript, Node, Express, Mongodb , React, Strapi CMS and
//                 Drupal CMS
//               </span>{" "}
//             </li>
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Experience;

import React, { useContext } from "react";
import { ThemeContext } from "../themeProvider";

const Experience = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div
      id="experience"
      className={darkMode === true ? "bg-gray-100" : "bg-gray-700"}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-8">
        <h2
          className={
            darkMode
              ? "text-5xl font-bold text-center"
              : "text-5xl font-bold text-center text-white"
          }
        >
          WORK EXPERIENCE
        </h2>
        <div
          className={
            darkMode
              ? "mt-4 text-xl text-justify"
              : "mt-4 text-xl text-justify text-white"
          }
        >
          <div className="text-center">
            <h2
              className={
                darkMode
                  ? "text-xl font-bold text-black"
                  : "text-xl font-bold text-white"
              }
            >
              Indus Net Technologies Pvt Ltd
            </h2>
            <h3 className="text-sm font-bold">
              Sep 2022 - May 2024 | Kolkata
            </h3>
          </div>
          <ul className="ml-4 sm:ml-10 md:ml-20 list-disc">
            <li>
              Worked on multiple internal or external projects involving front-end and back-end development.
            </li>
            <li>
              Implemented user authentication and data encryption for enhanced security.
            </li>
            <li>
              Utilized Node.js, Express.js, MongoDB, Swagger, and Git for development, documentation, and version control.
            </li>
            <li>
              Participated in code reviews, debugging, and troubleshooting to maintain code quality.
            </li>
            <li>
              Implemented Redux-toolkit for efficient state management, enhancing application performance.
            </li>
            <li>
              Contributed to the development of a reusable component library for future implementation.
            </li>
            <li>
              Solid experience with{" "}
              <span className="font-bold">
                HTML, Javascript, Node, Express, MongoDB, React, Strapi CMS, and Drupal CMS
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Experience;
